import courseService from '../services/courses'
import {
  LOAD_COURSES,
  CREATE_COURSE,
  GET_ALL_COURSES,
  DELETE_COURSE,
  LOAD_ENROLLMENT,
  ENROLL_COURSE,
  UN_ENROLL_COURSE,
  UPDATE_COURSE,
  UPLOAD_CERTIFICATE,
  GET_COURSE_CERTIFICATES
} from '../actions/course'

import { notification } from 'antd'

const courseReducer = (state = { data: [], loading: false }, action) => {
  switch (action.type) {
    case LOAD_COURSES:
      return { data: state.data, loading: true }
    case GET_ALL_COURSES:
      return { data: action.data, loading: false }
    case UPDATE_COURSE:
      return {
        data: state.data.map((course) => {
          if (course.id === action.courseId)
            return {
              ...action.data,
              enrolled: course.enrolled,
              privilege: course.privilege
            }
          else return course
        }),
        loading: false
      }
    case CREATE_COURSE:
      return { data: action.data, loading: false }
    case DELETE_COURSE:
      return {
        data: state.data.filter((course) => course.id !== action.courseId),
        loading: false
      }
    case ENROLL_COURSE:
      return { data: action.data, loading: false }
    case UN_ENROLL_COURSE:
      return { data: action.data, loading: false }
    case LOAD_ENROLLMENT:
      return {
        data: state.data.map((course) => {
          if (course.id === action.courseId)
            return { ...course, loadingEnroll: true }
          else return course
        }),
        loading: false
      }
    case UPLOAD_CERTIFICATE:
      return { data: action.data, loading: false }
    case GET_COURSE_CERTIFICATES:
      return { ...state, courseCertificates: action.data }
    default:
      return state
  }
}

export const getAllCourses = (filter = 'published') => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_COURSES })
      const response = await courseService.getAllCourses(filter)
      dispatch({ type: GET_ALL_COURSES, data: response })
    } catch (error) {
      console.log(error)
      notification.error({
        message: `Couldn't load ${filter} courses`
      })
    }
  }
}

export const createCourse = (course) => {
  return async (dispatch) => {
    try {
      const response = await courseService.createCourse(course)
      dispatch({ type: CREATE_COURSE, data: response })
      notification.success({
        message: 'Course added successfully'
      })
      return response   
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't add course"
      })
      throw error
    }
  }
}

export const deleteCourse = (courseId) => {
  return async (dispatch) => {
    try {
      await courseService.deleteCourse(courseId)
      dispatch({ type: DELETE_COURSE, courseId })
      notification.success({
        message: 'This course is no longer available'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Course couldn't delete"
      })
    }
  }
}

export const enroll = (courseId, userId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_ENROLLMENT, courseId })
      const response = await courseService.enrollCourse(courseId, userId)
      dispatch({ type: ENROLL_COURSE, data: response })
      notification.success({
        message: 'You are now enrolled in the course.'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Course couldn't enroll"
      })
    }
  }
}

export const unEnroll = (courseId, userId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_ENROLLMENT, courseId })
      const response = await courseService.UnenrollCourse(courseId, userId)
      dispatch({ type: UN_ENROLL_COURSE, data: response })
      notification.success({
        message: 'You are no longer enrolled in this course.'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Course couldn't Unenroll"
      })
    }
  }
}

export const createCourseCerti = (courseId, formData) => {
  return async (dispatch) => {
    try {
      const response = await courseService.createCourseCertificate(courseId, formData)
      dispatch({
        type: UPLOAD_CERTIFICATE, data: response
      })
      notification.success({
        message: 'Course certificate added successfully'
      })
      return response   
    } catch (error) {
      console.log(error)
      notification.error({
        message: error?.response?.data?.error || "Couldn't add course certificate"
      })
      throw error
    }
  }
}

export const getCourseCertificates = (courseId) => {
  return async (dispatch) => {
    try {
      const response = await courseService.getCourseCertificates(courseId)
      dispatch({ type: GET_COURSE_CERTIFICATES, data: response })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't load course certificates"
      })
    }
  }
}

export default courseReducer
